/* eslint-disable no-console */
import { apiClient } from '../baseClient';
import { CompanyData } from './types';

export const companyClient = {
  /**
   * Get list of all companies
   * @returns {Promise<{ results: CompanyData[]; count: number }>} List of enabled module keys
   */
  async getAllCompanies(params: {
    limit: number;
    ordering: string;
  }): Promise<{ results: CompanyData[]; count: number }> {
    try {
      const response = await apiClient.get<{
        results: CompanyData[];
        count: number;
      }>('companies/all/', params);
      return response;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};

export default companyClient;
